import { Link, useLocation } from "../lib/router.js";

const TABS = [
  { to: "/admin/users", label: "Users" },
  { to: "/admin/invitations", label: "Invitations" },
  { to: "/admin/audit", label: "Audit log" },
  { to: "/admin/system", label: "System" },
  { to: "/admin/ai", label: "AI" }
];

export function AdminTabs() {
  const path = useLocation();
  const active = (to: string) => path === to || (to === "/admin/users" && path === "/admin");
  return (
    <div className="segmented mt-4" style={{ marginBottom: "var(--space-5)" }}>
      {TABS.map((tab) => (
        <Link
          key={tab.to}
          to={tab.to}
          className={active(tab.to) ? "active" : ""}
          // segmented styles target <button>, but anchors share them via class
        >
          {tab.label}
        </Link>
      ))}
    </div>
  );
}
